// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"44583f9c","404":"e61cd3e9","787":"3a82c916"}[chunkId] + ".chunk.js";
};